<template>
  <div class="wrap_media">
    <div class="wrap_iframe"><div id="player"></div></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'youtubeMedia',
  props: {
    msg: String
  },
  computed: {
    ...mapState([
      'isMobile'
    ]),
  },
  data () {
    return {

    }
  },
  mounted () {
    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    var player;
    const youtubeId = this.isMobile ? 'mZla4pn5xR8' : 'zudEkYeiPW4'
    const playList = ['','','',''].map(() => youtubeId)
    const startTime = this.isMobile ? 2000 : 500
    const size = {
      width: this.isMobile ? 415 : 1600,
      height: this.isMobile ? 736 : 900
    }
    function onYouTubeIframeAPIReady() {
      player = new YT.Player('player', {
        width: size.width,
        height: size.height,
        videoId: youtubeId,
        playerVars: {
          'playsinline': 1,
          'autoplay': 1,
          'controls': 0,
          'modestbranding': 1,
          'rel': 0,
          'showinfo': 0,
          'iv_load_policy': 3,
          'autohide': 1,
          'loop': 1,
          'playlist': playList
        },
        events: {
          'onReady': onPlayerReady
        }
      });
    }

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
      event.target.mute();
      event.target.playVideo();
    }

    // 5. The API calls this function when the player's state changes.
    //    The function indicates that when playing a video (state=1),
    //    the player should play for six seconds and then stop.
    let done = false;
    function onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING && !done) {
        // setTimeout(stopVideo, 6000);
        done = true;
      }
    }
    function stopVideo() {
      player.stopVideo();
    }
    setTimeout(() => {
      onYouTubeIframeAPIReady();
    }, startTime)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.wrap_media {
  position: relative;
  width: 100%;
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    display: block;
    width: 100%;
    height: 100%;
  }
  iframe {
    width: 100% !important;
  }
}
</style>
